import React, { useState } from "react";
import {
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Button,
  List,
  ListItem,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import "./nav.css";

import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { Link, useParams } from "react-router-dom";
import BitstoxLogo from "src/images/bitstock logo.png";
import BitstoxLogoMobile from "src/images/bitstock logo.png";
import Watchlist from "src/images/home/watchlist.png";
import Portfolio from "src/images/home/Portfolio.png";
import Coin from "../home/coin";

const Nav = () => {
  const [cryptocurrenciesAnchorEl, setCryptocurrenciesAnchorEl] =
    useState(null);
  const [exchangesAnchorEl, setExchangesAnchorEl] = useState(null);
  const [nftAnchorEl, setNftAnchorEl] = useState(null);
  const [productsAnchorEl, setProductsAnchorEl] = useState(null);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [cryptocurrenciesMobileAnchorEl, setCryptocurrenciesMobileAnchorEl] =
    useState(null);
  const [exchangesMobileAnchorEl, setExchangesMobileAnchorEl] = useState(null);
  const [nftMobileAnchorEl, setNftMobileAnchorEl] = useState(null);
  const [productsMobileAnchorEl, setProductsMobileAnchorEl] = useState(null);

  // Handlers for Cryptocurrencies Mobile menu
  const handleCryptocurrenciesMobileMenuOpen = (event) => {
    setCryptocurrenciesMobileAnchorEl(event.currentTarget);
  };
  const handleCryptocurrenciesMobileMenuClose = () => {
    setCryptocurrenciesMobileAnchorEl(null);
  };

  // ===================== Cryptocurrencies end=========================================

  // Handlers for Exchanges Mobile menu
  const handleExchangesMobileMenuOpen = (event) => {
    setExchangesMobileAnchorEl(event.currentTarget);
  };
  const handleExchangesMobileMenuClose = () => {
    setExchangesMobileAnchorEl(null);
  };

  // ======================  Exchanges end =================================================

  // Handlers for Nft menu
  const handleNftMobileMenuOpen = (event) => {
    setNftMobileAnchorEl(event.currentTarget);
  };
  const handleNftMobileMenuClose = () => {
    setNftMobileAnchorEl(null);
  };
  // ======================== Nft end ===============================================

  // Handlers for Products Mobile menu
  const handleProductsMobileMenuOpen = (event) => {
    setProductsMobileAnchorEl(event.currentTarget);
  };
  const handleProductsMobileMenuClose = () => {
    setProductsMobileAnchorEl(null);
  };
  // ===================== Products end=========================================

  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  const handleScroll = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <IconButton
        className="MenuIconBtn"
        edge="end"
        color="inherit"
        onClick={toggleMobileMenu}
        sx={{ display: { xs: "block", lg: "none" } }}
      >
        {mobileMenuOpen ? <CloseIcon /> : <MenuIcon />}
      </IconButton>

      <img
        src={BitstoxLogoMobile}
        style={{ height: 55 }}
        className="homeLogoMobile"
        alt="Bitstox Logo"
      />
      {/* Mobile Menu Button */}
      {/* Mobile Dropdown Menu */}
      {mobileMenuOpen && (
        <Box className="mobileHomeMenu">
          {/* Cryptocurrencies Dropdown mobile */}
          <Button onClick={handleMenuOpen} className="navLink">
            C-LIP Products
          </Button>
          <Button className="navLink">Training </Button>
          <Button className="navLink">FAQ </Button>
          <Button onClick={() => handleScroll("section1")} className="navLink">
            News{" "}
          </Button>
          <Button className="navLink">Contact </Button>
          <Button
            onClick={handleCryptocurrenciesMobileMenuOpen}
            aria-controls={
              cryptocurrenciesMobileAnchorEl
                ? "CryptocurrenciesMobile"
                : undefined
            }
            aria-haspopup="true"
            className="navLink"
          >
            <span>Cryptocurrencies </span>
          </Button>
          <Menu
            id="CryptocurrenciesMobile"
            anchorEl={cryptocurrenciesMobileAnchorEl}
            open={Boolean(cryptocurrenciesMobileAnchorEl)}
            onClose={handleCryptocurrenciesMobileMenuClose}
            className="menuDropdownBox"
          >
            <MenuItem onClick={handleCryptocurrenciesMobileMenuClose}>
              {" "}
              <a href="/">
                {" "}
                <i class="ri-bar-chart-2-line"></i> By Marketcap
              </a>{" "}
            </MenuItem>
            <MenuItem onClick={handleCryptocurrenciesMobileMenuClose}>
              {" "}
              <a href="/?crypto=categories">
                <i class="ri-apps-2-line"></i> Categories{" "}
              </a>
            </MenuItem>

            <Box className="navdivider">
              {" "}
              <b>Popular</b>{" "}
            </Box>

            <MenuItem onClick={handleCryptocurrenciesMobileMenuClose}>
              <a href="">
                {" "}
                <i class="ri-list-check"></i> Highlights{" "}
              </a>{" "}
            </MenuItem>
            <MenuItem onClick={handleCryptocurrenciesMobileMenuClose}>
              {" "}
              <a href="">
                {" "}
                <i class="ri-star-s-line"></i> New Cryptocurrencies{" "}
              </a>
            </MenuItem>
            <MenuItem onClick={handleCryptocurrenciesMobileMenuClose}>
              {" "}
              <a href="">
                <i class="ri-trophy-line"></i> Gainers & Losers{" "}
              </a>{" "}
            </MenuItem>
          </Menu>

          {/* Exchanges Dropdown mobile */}
          <Button
            onClick={handleExchangesMobileMenuOpen}
            aria-controls={
              exchangesMobileAnchorEl ? "ExchangesMobile" : undefined
            }
            aria-haspopup="true"
            className="navLink"
          >
            <span>Exchanges</span>
          </Button>
          <Menu
            id="ExchangesMobile"
            anchorEl={exchangesMobileAnchorEl}
            open={Boolean(exchangesMobileAnchorEl)}
            onClose={handleExchangesMobileMenuClose}
            className="menuDropdownBox"
          >
            <MenuItem onClick={handleExchangesMobileMenuClose}>
              {" "}
              <a href="/exchange-rate">
                {" "}
                <i class="ri-bank-line"></i> Crypto Exchanges
              </a>{" "}
            </MenuItem>
            {/* <MenuItem onClick={handleExchangesMobileMenuClose}>
              {" "}
              <a href="">
                <i class="ri-store-2-fill"></i> Decentralized Exchanges
              </a>{" "}
            </MenuItem> */}
            <MenuItem onClick={handleExchangesMobileMenuClose}>
              <a href="/exchange-rate?exchange=derivatives">
                {" "}
                <i class="ri-line-chart-fill"></i> Derivatives{" "}
              </a>{" "}
            </MenuItem>
          </Menu>
          {/* NFT Dropdown mobile */}

          <Button
            onClick={handleNftMobileMenuOpen}
            aria-controls={nftMobileAnchorEl ? "NftMobile" : undefined}
            aria-haspopup="true"
            className="navLink"
          >
            <span>NFT</span>
          </Button>

          <Menu
            id="NftMobile"
            anchorEl={nftMobileAnchorEl}
            open={Boolean(nftMobileAnchorEl)}
            onClose={handleNftMobileMenuClose}
            className="menuDropdownBox"
          >
            <MenuItem onClick={handleNftMobileMenuClose}>
              {" "}
              <a href="/?nft=floor">
                <i className="ri-bank-line"></i> NFT Floor Price
              </a>
            </MenuItem>
          </Menu>

          {/* Products Dropdown mobile */}

          <Button
            onClick={handleProductsMobileMenuOpen}
            aria-controls={
              productsMobileAnchorEl ? "ProductsMobile" : undefined
            }
            aria-haspopup="true"
            className="navLink"
          >
            <span> Products</span>
          </Button>
          <Menu
            id="ProductsMobile"
            anchorEl={productsMobileAnchorEl}
            open={Boolean(productsMobileAnchorEl)}
            onClose={handleProductsMobileMenuClose}
            className="menuDropdownBox"
          >
            <MenuItem onClick={handleProductsMobileMenuClose}>
              {" "}
              <a href="">
                {" "}
                <i class="ri-mail-star-fill"></i> Crypto Portfolio{" "}
              </a>{" "}
            </MenuItem>
            <MenuItem onClick={handleProductsMobileMenuClose}>
              {" "}
              <a href="">
                <i class="ri-smartphone-line"></i> Bitstox App (Coming Soon)
              </a>
            </MenuItem>
          </Menu>
        </Box>
      )}
      {/* ======================================  mobile menu end        ============================================================================ */}

      <Box position="static" className="navBar">
        <Toolbar className="navLeftBox">
          <Box sx={{ flexGrow: 1, mt: -1.5 }}>
            <img
              src={BitstoxLogo}
              className="homeLogo"
              alt="Bitstox Logo"
              style={{ height: 65 }}
            />
          </Box>

          <Box
            sx={{ display: { xs: "none", lg: "flex" }, gap: 2 }}
            className="navBox"
          >
            {/* Cryptocurrencies Dropdown */}
            <Box className="navItem">
              <Button onClick={handleMenuOpen} className="navLink">
                C-LIP Products
              </Button>
            </Box>
            <Box className="navItem">
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                sx={{
                  mt: 1,
                  "& .MuiMenu-paper": {
                    borderRadius: "12px",
                    boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.2)",
                    background: "white",
                    minWidth: "150px",
                  },
                }}
              >
                <MenuItem
                  onClick={handleMenuClose}
                  sx={{
                    "&:hover": { background: "#f5f5f5" },
                  }}
                >
                  <Link
                    to="/"
                    style={{ textDecoration: "none", color: "black" }}
                  >
                    FIP
                  </Link>
                </MenuItem>
                <MenuItem
                  onClick={handleMenuClose}
                  sx={{
                    "&:hover": { background: "#f5f5f5" },
                  }}
                >
                  <Link
                    to="/"
                    style={{ textDecoration: "none", color: "black" }}
                  >
                    SIP
                  </Link>
                </MenuItem>
                <MenuItem
                  onClick={handleMenuClose}
                  sx={{
                    "&:hover": { background: "#f5f5f5" },
                  }}
                >
                  <Link
                    to="/"
                    style={{ textDecoration: "none", color: "black" }}
                  >
                    IDP
                  </Link>
                </MenuItem>
                <MenuItem
                  onClick={handleMenuClose}
                  sx={{
                    "&:hover": { background: "#f5f5f5" },
                  }}
                >
                  <Link
                    to="/"
                    style={{ textDecoration: "none", color: "black" }}
                  >
                    FDP - Coming Soon
                  </Link>
                </MenuItem>
              </Menu>
            </Box>
            <Box className="navItem">
              <Button className="navLink">Training </Button>
            </Box>
            <Box className="navItem">
              <Button className="navLink">FAQ </Button>
            </Box>
            <Box className="navItem">
              <Button
                onClick={() => handleScroll("section1")}
                className="navLink"
              >
                News{" "}
              </Button>
            </Box>
            <Box className="navItem">
              <Button className="navLink">Contact </Button>
            </Box>
            <Box className="navItem">
              <Button className="navLink">Cryptocurrencies</Button>
              <Box className="DesktopmenuDropdownBox">
                <List>
                  <ListItem>
                    <a href="/">
                      <i className="ri-bar-chart-2-line"></i> By Marketcap
                    </a>
                  </ListItem>
                  <ListItem>
                    <a href="/?crypto=categories">
                      <i className="ri-apps-2-line"></i> Categories
                    </a>
                  </ListItem>
                  {/* <ListItem>
                    <a href="">
                      <i className="ri-links-line"></i> Chain
                    </a>
                  </ListItem> */}
                  {/* <Box className="navdivider">
                    <b>Popular</b>
                  </Box>
                  <ListItem>
                    <a href="">
                      <i className="ri-list-check"></i> Highlights
                    </a>
                  </ListItem>
                  <ListItem>
                    <a href="">
                      <i className="ri-star-s-line"></i> New Cryptocurrencies
                    </a>
                  </ListItem>
                  <ListItem>
                    <a href="">
                      <i className="ri-trophy-line"></i> Gainers & Losers
                    </a>
                  </ListItem> */}
                </List>
              </Box>
            </Box>

            {/* Exchanges Dropdown */}
            <Box className="navItem">
              <Button className="navLink">Exchanges</Button>
              <Box className="DesktopmenuDropdownBox">
                <List>
                  <ListItem>
                    <a href="/exchange-rate">
                      <i className="ri-bank-line"></i> Crypto Exchanges
                    </a>
                  </ListItem>
                  {/* <ListItem>
                    <a href="">
                      <i className="ri-store-2-fill"></i> Decentralized
                      Exchanges
                    </a>
                  </ListItem> */}
                  <ListItem>
                    <a href="/exchange-rate?exchange=derivatives">
                      <i className="ri-line-chart-fill"></i> Derivatives
                    </a>
                  </ListItem>
                </List>
              </Box>
            </Box>

            {/* NFT Dropdown */}
            <Box className="navItem">
              <Button className="navLink">NFT</Button>
              <Box className="DesktopmenuDropdownBox">
                <List>
                  <ListItem>
                    <a href="/?nft=floor">
                      <i className="ri-bank-line"></i> NFT Floor Price
                    </a>
                  </ListItem>
                </List>
              </Box>
            </Box>

            {/* Products Dropdown */}
            <Box className="navItem">
              <Button className="navLink">Products</Button>
              <Box className="DesktopmenuDropdownBox">
                <List>
                  <ListItem>
                    <a href="">
                      <i className="ri-mail-star-fill"></i> Crypto Portfolio
                    </a>
                  </ListItem>
                  <ListItem>
                    <a href="">
                      <i className="ri-smartphone-line"></i> Bitstox App (Coming
                      Soon)
                    </a>
                  </ListItem>
                </List>
              </Box>
            </Box>
          </Box>
        </Toolbar>

        <Box className="navRightBox">
          <List className="watChPortfolioList">
            {/* <ListItem>
              {" "}
              <img src={Watchlist} /> Watchlist{" "}
            </ListItem>
            <ListItem>
              {" "}
              <img src={Portfolio} /> Portfolio{" "}
            </ListItem> */}
          </List>
          {/* 
          <Box className="homeSeachBox">
            <TextField
              variant="outlined"
              placeholder="Search..."
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Box> */}
        </Box>
      </Box>
    </>
  );
};

export default Nav;
